import { observer } from 'mobx-react-lite'
import { ViewTypes } from 'stores/NotificationsStore'
import { useRootStore } from 'stores/RootStore'
import { Bell, BellInactive } from 'blaze-ui/icons'
import { Button } from 'blaze-components/WriterTopBar/Button'

export const NotificationsWriterTrigger = observer(() => {
  const { notifications } = useRootStore()
  const currentView = notifications.currentView

  const handlePress = () => {
    notifications.setCurrentView(currentView ? null : ViewTypes.Unread)
  }

  let icon = Bell
  if (notifications.mutedAt) icon = BellInactive

  return <Button onPress={handlePress} icon={icon} aria-label="Notifications" />
})
